import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActions = ({
  onContinueLearning = () => { },
  onViewProgress = () => { },
  onTakeQuiz = () => { },
  hasActiveChapter = true,
  className = ""
}) => {
  const quickActionItems = [
    {
      id: 'continue',
      title: 'Continue Learning',
      description: 'Resume your current chapter',
      icon: 'Play',
      color: 'primary',
      action: onContinueLearning,
      route: '/interactive-presentation-viewer',
      enabled: hasActiveChapter
    },
    {
      id: 'progress',
      title: 'View Progress',
      description: 'Track your learning journey',
      icon: 'TrendingUp',
      color: 'secondary',
      action: onViewProgress,
      route: '/learning-progress-tracker',
      enabled: true
    },
  ];

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {quickActionItems.map((item) => (
          <div key={item.id} className="group">
            {item.enabled ? (
              <Link to={item.route}>
                <div className={`
                    p-4 rounded-lg border-2 border-transparent transition-all duration-200 ease-out
                    hover:border-${item.color}-200 hover:shadow-md cursor-pointer
                    bg-${item.color}-50 hover:bg-${item.color}-100
                  `}>
                  <div className="flex flex-col items-center space-y-3 text-center">
                    <div className={`
                        flex items-center justify-center w-12 h-12 rounded-lg
                        bg-${item.color} group-hover:scale-110 transition-transform duration-200
                      `}>
                      <Icon
                        name={item.icon}
                        size={24}
                        color="white"
                        strokeWidth={2}
                      />
                    </div>

                    <div>
                      <h3 className="mb-1 font-semibold font-heading text-text-primary">
                        {item.title}
                      </h3>
                      <p className="text-xs text-text-secondary">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ) : (
              <div className={`
                  p-4 rounded-lg border-2 border-border bg-surface-secondary
                  opacity-60 cursor-not-allowed
                `}>
                <div className="flex flex-col items-center space-y-3 text-center">
                  <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-text-muted">
                    <Icon
                      name={item.icon}
                      size={24}
                      color="white"
                      strokeWidth={2}
                    />
                  </div>

                  <div>
                    <h3 className="mb-1 font-semibold font-heading text-text-muted">
                      {item.title}
                    </h3>
                    <p className="text-xs text-text-muted">
                      Complete a chapter first
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;